import { type CardTabListType } from 'antd/lib/card';
import i18n from 'i18next';

import { type PresetFilterType } from 'components/DataTable';
import { tableStorage } from 'components/DataTable/utils';
import { AtlasGqlConfirmationStatus } from 'types/atlas-graphql';

export const SITE_DAMAGE_LIST_TABLE_ID = 'site-damage-list-table2';
export const DAMAGE_LIST_TABLE_ID = 'damage-list-table2';

export const isSiteDamageListTable = (id: string) => id === SITE_DAMAGE_LIST_TABLE_ID;

type GetConfirmedTabListParams = {
  critical?: boolean;
  isSiteDetailsPage: boolean;
  assetIds?: string[];
};

export const getConfirmedTabList = ({
  critical = false,
  isSiteDetailsPage,
  assetIds,
}: GetConfirmedTabListParams): (CardTabListType & PresetFilterType)[] => [
  {
    key: 'ALL',
    tab: i18n.t('table.all', 'All'),
    value: {
      filters: {
        confirmationStatus: undefined,
        site: isSiteDetailsPage ? assetIds : undefined,
      },
      sortOrder: {
        columnKey: critical ? 'Severity' : 'Date',
        order: 'descend',
      },
    },
  },
  {
    key: 'CONFIRMED',
    tab: i18n.t('table.confirmed', 'Confirmed'),
    value: {
      filters: {
        confirmationStatus: [AtlasGqlConfirmationStatus.Confirmed],
        site: isSiteDetailsPage ? assetIds : undefined,
      },
    },
  },
  {
    key: 'UNCONFIRMED',
    tab: i18n.t('table.unconfirmed', 'Unconfirmed'),
    value: {
      filters: {
        confirmationStatus: [
          AtlasGqlConfirmationStatus.NotConfirmed,
          AtlasGqlConfirmationStatus.ConfirmedUpdated,
        ],
        site: isSiteDetailsPage ? assetIds : undefined,
      },
    },
  },
];

export const getInitialPresetFilter = (
  params: GetConfirmedTabListParams & { defaultActiveTabKey?: string }
) => {
  const { defaultActiveTabKey = 'ALL', ...tabListParams } = params;
  return getConfirmedTabList(tabListParams).find(tab => tab.key === defaultActiveTabKey);
};

/**
 * Removes the persisted per-customer state (sort/filter/pagination) for the Inspections
 * Damage table 2.0 list, so table state does not leak between orgs when switching customers
 * or logging out.
 */
export const clearDamageListTable2 = () => {
  const { remove } = tableStorage({ storageKey: DAMAGE_LIST_TABLE_ID });
  remove();
};
